<template>
  <div>
    <br>
    <br><br>
    <br><br>
    <div class="page-inner">
      <div class="row">
        <div class="col-12 position-relative">
          <div class="loading-container" v-if="loading">
            <div class="lds-dual-ring"></div>
            <span class="d-block text-center">Loading</span>
          </div>
          <button class="download-pdf btn btn-primary" @click="createpdf()" v-if="receiptInfo"><i class="far fa-file-pdf mr-2"></i>Download PDF</button>
          <div v-if="receiptInfo === null && !loading" class="text-center">
            {{ $t('get_receipt_error') }}
          </div>
          <div id="element-to-print">
            <!-- subscripcion -->
            <table align="center" v-if="$route.meta.mode === 'subscription' && receiptInfo" style="background-color: #f6f9fc;" width="100%">
              <tbody>
                <tr>
                  <td>
                    <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background-color: #ffffff; color: #000000; width: 720px;" width="720">
                      <tbody>
                        <tr>
                          <td style="width:100%;padding-right:0px;">
                            <div style="height: 68px;">
                              <img :src="imgPdfs.logo" style="display: block; height: auto; border: 0; width: 120px; max-width: 100%;" width="120"/>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <div style="color:#525f7f;font-family:Verdana, Geneva, sans-serif;letter-spacing:0px;line-height:1.5;padding-top:60px;padding-right:60px;padding-bottom:25px;padding-left:60px;">
                            <div style="font-size: 14px; line-height: 1.5; font-family: Verdana, Geneva, sans-serif; color: #525f7f; letter-spacing: 0px;">
                              <p style="margin: 0; font-size: 20px; line-height: 1.5; word-break: break-word; letter-spacing: normal; margin-top: 0; margin-bottom: 0;"><span style="font-size: 20px;"><strong><span style="">Thank you for your purchase!</span></strong></span></p>
                              <p style="margin: 0; font-size: 14px; line-height: 1.5; word-break: break-word; letter-spacing: normal; margin-top: 0; margin-bottom: 0;">&nbsp;</p>
                              <p style="margin: 0; font-size: 16px; line-height: 1.5; word-break: break-word; letter-spacing: normal; margin-top: 0; margin-bottom: 0;"><span style="font-size: 16px;">Hi <b>{{receiptInfo.name}}</b>, here's Your receipt:</span></p>
                              <p style="margin: 0; line-height: 1.5; word-break: break-word; letter-spacing: normal; margin-top: 0; margin-bottom: 0;">&nbsp;</p>
                              <p style="margin: 0; line-height: 1.5; word-break: break-word; letter-spacing: normal; margin-top: 0; margin-bottom: 0;">&nbsp;</p>
                              <p style="margin: 0; line-height: 1.5; word-break: break-word; font-size: 16px; letter-spacing: normal; margin-top: 0; margin-bottom: 0;"><span style="font-size: 16px;">Total value of the transaction: <strong>{{receiptInfo.money}}</strong></span></p>
                              <p style="margin: 0; line-height: 1.5; word-break: break-word; font-size: 16px; letter-spacing: normal; margin-top: 0; margin-bottom: 0;"><span style="font-size: 16px;">Service type: <strong>Subscription {{receiptInfo.typeService}} Indiefy Pro</strong></span></p>
                              <p style="margin: 0; line-height: 1.5; word-break: break-word; font-size: 16px; letter-spacing: normal; margin-top: 0; margin-bottom: 0;"><span style="font-size: 16px;">Invoice Id: <strong>{{receiptInfo.invoiceID}}</strong></span></p>
                              <p style="margin: 0; line-height: 1.5; word-break: break-word; letter-spacing: normal; margin-top: 0; margin-bottom: 0;">&nbsp;</p>
                              <p style="margin: 0; line-height: 1.5; word-break: break-word; letter-spacing: normal; margin-top: 0; margin-bottom: 0;">&nbsp;</p>
                              <p style="margin: 0; line-height: 1.5; word-break: break-word; font-size: 16px; letter-spacing: normal; margin-top: 0; margin-bottom: 0;"><span style="font-size: 16px;">This receipt confirms the start of your service to Indiefy Pro, in case you want to cancel your membership please visit <a href="https://indiefy.net/account/subscription" rel="noopener" style="text-decoration: underline; color: #8a3b8f;" target="_blank"><span style="color: #7400ff;"><u>the following link.</u></span></a></span></p>
                              <p style="margin: 0; line-height: 1.5; word-break: break-word; letter-spacing: normal; margin-top: 0; margin-bottom: 0;">&nbsp;</p>
                              <p style="margin: 0; line-height: 1.5; word-break: break-word; letter-spacing: normal; margin-top: 0; margin-bottom: 0;">&nbsp;</p>
                              <p style="margin: 0; line-height: 1.5; word-break: break-word; font-size: 16px; letter-spacing: normal; margin-top: 0; margin-bottom: 0;"><span style="font-size: 16px;">If you have any problems with your membership please contact us via our support team and we will get back to you as soon as possible.</span></p>
                              <p style="margin: 0; line-height: 1.5; word-break: break-word; letter-spacing: normal; margin-top: 0; margin-bottom: 0;">&nbsp;</p>
                              <p style="margin: 0; line-height: 1.5; word-break: break-word; letter-spacing: normal; margin-top: 0; margin-bottom: 0;">&nbsp;</p>
                              <p style="margin: 0; line-height: 1.5; word-break: break-word; font-size: 16px; letter-spacing: normal; margin-top: 0; margin-bottom: 0;"><span style="font-size: 16px;">Indiefy Team.</span></p>
                              <p style="margin: 0; line-height: 1.5; word-break: break-word; letter-spacing: normal; margin-top: 0; margin-bottom: 0;">&nbsp;</p>
                            </div>
                          </div>
                        </tr>
                        <tr>
                          <td style="font-size: 1px; line-height: 1px; border-top: 1px solid #BBBBBB;"><span>&nbsp;</span></td>
                        </tr>
                        <tr>
                          <td style="padding-bottom:40px;padding-left:60px;padding-right:10px;padding-top:10px;">
                            <div style="font-family: Verdana, sans-serif">
                              <div style="font-size: 14px; font-family: Verdana, Geneva, sans-serif; color: #393d47; line-height: 1.2;">
                                <p style="margin: 0; font-size: 14px;"><span style="font-size:11px;color:#a9afbe;">Indiefy, Av. Circunvalación Agustín Yáñez 2820, Vallarta, 44690 Guadalajara, Jal.</span></p>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-- Regalias -->
            <table align="center" v-if="$route.meta.mode === 'payout' && receiptInfo" style="background-color: #f6f9fc;" width="100%">
              <tbody>
                <tr>
                  <td>
                    <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background-color: #ffffff; color: #000000; width: 600px;" width="600">
                      <tbody>
                        <tr>
                          <td style="width:100%;padding-right:0px;">
                            <div style="height: 68px;">
                              <img :src="imgPdfs.logo" class="max-width"  width="1029"   height=""  alt="Indiefy - Free Digital Distribution" border="0" style="display: block; color: #000; text-decoration: none; font-family: Helvetica, arial, sans-serif; font-size: 16px;  max-width: 1029px !important; width: 100% !important; height: auto !important; " />
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style="padding-left:60px; padding-top:25px; text-align:center; width:100%;">
                            <h1 style="margin: 0; color: #525f7f; direction: ltr; font-family: Verdana, Geneva, sans-serif; font-size: 12px; font-weight: normal; letter-spacing: normal; line-height: 120%; text-align: left; margin-top: 0; margin-bottom: 0;">
                              RECEIPT {{receiptInfo.paymentDate}} - {{receiptInfo.receiptID}}
                            </h1>
                          </td>
                        </tr>
                        <tr>
                          <td style="padding-bottom:25px;padding-left:60px;padding-right:60px;padding-top:40px;">
                            <div style="font-size: 14px; color: #525f7f; line-height: 1.5;">
                              <p style="margin: 0; font-size: 16px; letter-spacing: normal;">
                                <span style="font-size:30px; font-family: Verdana, sans-serif"><strong><span style="">Payment sent!</span></strong></span>
                              </p>
                              <p style="margin: 0; font-size: 16px; letter-spacing: normal;">
                                <span style="font-size:14px; font-family: Verdana, sans-serif;"><br>Please check with your bank that the amount is reflected, in some cases it may take from 7-10 business days for the Bank to receive the payment.</span>&nbsp;
                              </p>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style="font-size: 1px; line-height: 1px; border-top: 1px solid #BBBBBB;"><span>&nbsp;</span></td>
                        </tr>
                        <tr>
                          <td style="padding-left:60px;padding-top:25px;text-align:center;width:100%;">
                            <h1 style="margin: 0; color: #525f7f; direction: ltr; font-family: Verdana, Geneva, sans-serif; font-size: 16px; font-weight: normal; letter-spacing: normal; line-height: 120%; text-align: left; margin-top: 0; margin-bottom: 0;">
                              Payment method: <b>{{receiptInfo.paymentMethod}}<br/></b>Artist: <b>{{receiptInfo.name}}</b><br/>Country: <b>{{receiptInfo.country}}</b>
                            </h1>
                          </td>
                        </tr>
                        <tr>
                          <td style="padding-bottom:60px;padding-left:60px;padding-right:60px;padding-top:40px;">
                            <table align="center" border="0" cellpadding="0" cellspacing="0" class="row-content stack" role="presentation" style="background-color: #ffffff; color: #000000; width: 600px;" width="600">
                              <tbody>
                                <tr>
                                  <td class="column" style="font-weight: 400; text-align: left; vertical-align: top; border-top: 0px; border-right: 0px; border-bottom: 0px; border-left: 0px;" width="50%">
                                    <div style="font-size: 14px; font-family: Verdana, Geneva, sans-serif; 8px; color: #525f7f; line-height: 1.2;">
                                      <p style="margin: 0; font-size: 16px;"><span style="font-size:16px;"><strong>Payment Amount </strong></span></p>
                                      <p style="margin: 0; font-size: 16px;"><span style="font-size:16px;">{{receiptInfo.amount}}</span></p>
                                    </div>
                                  </td>
                                  <td class="column" style="font-weight: 400; text-align: left; vertical-align: top; border-top: 0px; border-right: 0px; border-bottom: 0px; border-left: 0px;" width="50%">
                                    <div style="font-size: 14px; font-family: Verdana, Geneva, sans-serif; color: #525f7f; line-height: 1.2;">
                                      <p style="margin: 0; font-size: 14px; text-align: left;"><span style="font-size:16px;">
                                        <strong>Payment Date<br/></strong>{{receiptInfo.paymentDate}}</span>
                                      </p>
                                    </div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                        <tr>
                          <td style="padding-bottom:10px;padding-left:60px;padding-right:60px;padding-top:10px;">
                            <div style="font-family: Verdana, sans-serif">
                              <div style="font-size: 14px; font-family: Verdana, Geneva, sans-serif; color: #525f7f; line-height: 1.2;">
                                <p style="margin: 0; font-size: 14px;"><span style="font-size:14px;">Please contact our support team if your payment is not reflected in 7-10 days.</span></p>
                              </div>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style="font-size: 1px; line-height: 1px; border-top: 1px solid #BBBBBB;"><span>&nbsp;</span></td>
                        </tr>
                        <tr>
                          <td style="padding-bottom:40px;padding-left:60px;padding-right:10px;padding-top:10px;">
                            <div style="font-family: Verdana, sans-serif">
                              <div style="font-size: 14px; font-family: Verdana, Geneva, sans-serif; color: #393d47; line-height: 1.2;">
                                <p style="margin: 0; font-size: 14px;"><span style="font-size:11px;color:#a9afbe;">Indiefy, Av. Circunvalación Agustín Yáñez 2820, Vallarta, 44690 Guadalajara, Jal.</span></p>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'underscore'
import moment from 'moment'
import html2pdf from 'html2pdf.js'
import imgPdfs from '../data/img_pdfs'
import Receipt from '../services/receipts'

export default {
  name: 'Receipts',
  data: function () {
    return {
      imgPdfs: {
        logo: ''
      },
      loading: true,
      receiptInfo: null,
      currency: new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
    }
  },
  methods: {
    createpdf: function () {
      var element = document.getElementById('element-to-print')
      var opt = {
        margin: 1,
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
      }
      html2pdf().set(opt).from(element).save(this.$route.meta.mode + 'Receipt' + moment().unix())
    }
  },
  created: function () {
    this.imgPdfs = imgPdfs
    if (_.contains(['subscription', 'payout'], this.$route.meta.mode) && this.$route.params.id !== '') {
      Receipt.get(this.$route.meta.mode, this.$route.params.id).then(response => {
        this.loading = false
        if (response.data !== null) {
          if (this.$route.meta.mode === 'subscription') {
            this.receiptInfo = {
              money: this.currency.format(response.data.cost),
              typeService: (response.data.plan.charAt(0).toUpperCase() + response.data.plan.slice(1)),
              invoiceID: response.data._id
            }
            this.receiptInfo.name = (() => {
              let name = ''
              if (response.data.name) {
                name = response.data.name
              } else if (response.data.user.name && response.data.user.last_name) {
                name = response.data.user.name + ' ' + response.data.user.last_name
              } else if (!(_.contains(response.data.user.username, ['fb_', 'google_']))) {
                name = response.data.user.username
              } else {
                name = response.data.user.email
              }
              return name
            })()
          } else if (this.$route.meta.mode === 'payout') {
            this.receiptInfo = {
              amount: this.currency.format(response.data.amount),
              paymentDate: response.data.paidAt ? moment(response.data.paidAt).format('DD/MM/YYYY hh:mm:ss') : moment(response.data.updatedAt).format('DD/MM/YYYY hh:mm:ss'),
              country: response.data.user.country,
              receiptID: response.data._id,
              paymentMethod: response.data.payment_method ? (response.data.payment_method.charAt(0).toUpperCase() + response.data.payment_method.slice(1)) : 'Paypal'
            }
            this.receiptInfo.name = (() => {
              let name = ''
              if (response.data.artist.name) {
                name = response.data.artist.name
              } else if (response.data.user.name && response.data.user.last_name) {
                name = response.data.user.name + ' ' + response.data.user.last_name
              } else if (!(_.contains(response.data.user.username, ['fb_', 'google_']))) {
                name = response.data.user.username
              } else {
                name = response.data.user.email
              }
              return name
            })()
          }
        } else {

        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .download-pdf {
    position: absolute;
    top: 0;
    right: 10%;
  }
  #element-to-print {
    min-height: 400px;
  }
  .loading-container {
    position: fixed;
    top: calc(50% - 80px);
    right: calc(50% - 80px);
    .lds-dual-ring {
      display: inline-block;
      width: 80px;
      height: 80px;
    }
    .lds-dual-ring:after {
      content: " ";
      display: block;
      width: 64px;
      height: 64px;
      margin: 8px;
      border-radius: 50%;
      border: 6px solid #fff;
      border-color: #6b24a3 transparent #e12368 transparent;
      animation: lds-dual-ring 1.2s linear infinite;
    }
  }
  @keyframes lds-dual-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Receipts.vue